// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
//Last ADD : NEW'
// MODFIED DATA : 18-08-2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import AutoLoanCollectionActionTypes from './auto-loan-collection-report.types';
import {
	getAutoLoanCollectionDetailsFailure,
	getAutoLoanCollectionDetailsResponseChanged,
	getAutoLoanCollectionDetailsSuccess,
} from './auto-loan-collection-report.action';
import { autoLoanCollectionReportDetailsGet } from './auto-loan-collection-report.service';

/*************** Get Auto Loan Collection Details Start ******************/
export function* getAutoLoanCollectionReportDetails({ payload }: any) {
	try {
		const {
			databaseName,
			toDate,
			companyID,
			fromDate,
			funderID,
			branchID,
			centerID,
			generalCompanyID,
		} = payload;
		const key = 'GetAutoLoanCollectionReportKey';
		const jsonData = {
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			BranchID: branchID,
			CenterID: centerID,
			FunderID: funderID,
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(autoLoanCollectionReportDetailsGet, encodeData);
		console.log('responseData', responseData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAutoLoanCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getAutoLoanCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAutoLoanCollectionDetailsFailure(error));
	}
}

export function* resetFetchAutoLoanCollectionResponse() {
	yield put(getAutoLoanCollectionDetailsResponseChanged());
}

export function* onGetAutoLoanCollection() {
	yield takeLatest(
		AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_START,
		getAutoLoanCollectionReportDetails,
	);
}

export function* onGetAutoLoanCollectionResponseReset() {
	yield takeLatest(
		AutoLoanCollectionActionTypes.GET_AUTO_LOAN_REPORT_DETAILS_RESPONSE_RESET,
		resetFetchAutoLoanCollectionResponse,
	);
}
/*************** Get Auto Loan Collection Details End ******************/
export function* autoLoanCollectionReportSaga() {
	yield all([call(onGetAutoLoanCollection), call(onGetAutoLoanCollectionResponseReset)]);
}
